export default __webpack_public_path__ + "static/media/birds.22cd9dc0.png";